var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{staticClass:"ax-data-table-label-checkbox"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.value,"indeterminate":_vm.indeterminate},on:{"change":_vm.change}})])
}
var staticRenderFns = []

export { render, staticRenderFns }